import { ApolloClient } from '@apollo/client'
import { message } from 'antd'
import { openUrlInNewWindow } from '@Orders/OrderDetailsPage/logic'

import logger from '~/lib/logger'

import downloadInvoiceUriQuery from './downloadInvoiceUriQuery'

type ApolloClientType = ApolloClient<object>

export const downloadInvoiceUri = async ({
    client,
    setLoading,
    variables,
}: {
    client: ApolloClientType
    setLoading: (loading: boolean) => void
    variables: { name: string }
}) => {
    try {
        setLoading(true)

        const result = await client.query({
            query: downloadInvoiceUriQuery,
            variables,
            fetchPolicy: 'no-cache',
        })

        const downloadUrl = result?.data?.salesOrder?.downloadInvoiceUri

        if (downloadUrl) {
            openUrlInNewWindow(downloadUrl)
            message.success('Order confirmation downloaded')
        }
    } catch (err) {
        message.error('Failed to download order confirmation')
        logger.exception(err, {
            extra: {
                info: 'DownloadOrderConfirmationButton::Failed to download invoice uri',
                variables,
            },
        })
    } finally {
        setLoading(false)
    }
}
